import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { UserContext } from "../../App";
import getFirstAllowedRoute from "../../Utlis/GetFirstAllowedRoute";

import Select from "../../Pages/Public/Select";
import Dashboard from "../../Pages/FleeiqAdmin/Dashboard";
import FleetManegement from "../../Pages/FleeiqAdmin/FleetManagement";
import FuelVendors from "../../Pages/FleeiqAdmin/FuelVendors";
import Transactions from "../../Pages/FleeiqAdmin/Transactions";
import CreditsBillings from "../../Pages/FleeiqAdmin/CreditsBillings";
import ReportsAnalytics from "../../Pages/FleeiqAdmin/ReportsAnalytics";
import ApprovalsRequests from "../../Pages/FleeiqAdmin/ApprovalsRequests";
import UserManagement from "../../Pages/FleeiqAdmin/UserManagement";
import SettingsPermissions from "../../Pages/FleeiqAdmin/SettingsPermissions";

import FleetManagementDetail from "../../Pages/FleeiqAdmin/FleetManagement/FleetManagementDetail";
import EditCompanyOnboarding from "../../Pages/FleeiqAdmin/FleetManagement/EditCompanyOnboarding";

import FuelVendorDetails from "../../Pages/FleeiqAdmin/FuelVendors/FuelVendorDetails";
import EditVendorDetails from "../../Pages/FleeiqAdmin/FuelVendors/EditFuelVendor";

import TransactionDetails from "../../Pages/FleeiqAdmin/Transactions/TransactionDetails";

import CreditAdjustments from "../../Pages/FleeiqAdmin/CreditsBillings/CreditAdjustments";
import FleetCreditDetails from "../../Pages/FleeiqAdmin/CreditsBillings/FleetCompanyDetails";

import VendorOnboarding from "../../Pages/FleeiqAdmin/ApprovalsRequests/VendorOnboarding";
import CompanyOnboarding from "../../Pages/FleeiqAdmin/ApprovalsRequests/CompanyOnboarding";
import SubscriptionPaymentRequest from "../../Pages/FleeiqAdmin/ApprovalsRequests/SubscriptionPaymentRequest";

import UserDetails from "../../Pages/FleeiqAdmin/UserManagement/UserDetails";

import MyProfilePage from "../../Pages/FleeiqAdmin/MyProfile";
import AuditTrail from "../../Pages/FleeiqAdmin/AuditTrail";
import QRManagement from "../../Pages/FleeiqAdmin/QRManagement";
import QRActiveDetail from "../../Pages/FleeiqAdmin/QRManagement/QRActiveDetail";
import FuelCards from "../../Pages/FleeiqAdmin/QRManagement/FuelCards";

import SystemConfiguration from "../../Pages/FleeiqAdmin/SytemConfiguration";
import EditModulePrice from "../../Pages/FleeiqAdmin/SytemConfiguration/ModulePricing/EditModulePrice";

import FuelBrandDetails from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelBrands/FuelBrandDetails";
import AddFuelBrand from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelBrands/AddFuelBrand";
import EditFuelBrand from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelBrands/EditFuelBrand";

import EditFleetManagerDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/FleetManagerDocumentRequired/EditFleetManagerDocument";
import AddFleetManagerDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/FleetManagerDocumentRequired/AddFleetManagerDocument";
import AddVehicleDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/VehicleDocumentRequired/AddVehicleDocument";
import EditVehicleDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/VehicleDocumentRequired/EditVehicleDocument";
import AddDriverDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/DriverDocumentRequired/AddDriverDocument";
import EditDriverDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/DriverDocumentRequired/EditDriverDocument";

import AddFuelVendorDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelVendorDocumentRequired/AddFuelVendorDocument";
import EditFuelVendorDocument from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelVendorDocumentRequired/EditFuelVendorDocument";
import AddFuelType from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelTypes/AddFuelType";
import EditFuelType from "../../Pages/FleeiqAdmin/SytemConfiguration/FuelTypes/EditFuelType";
import SubscriptionPayments from "../../Pages/FleeiqAdmin/SubscriptionPayments";

const FleeiqAdminRoutes = ({ setUser }) => {
  const { userData } = useContext(UserContext);
  const fallbackRoute = getFirstAllowedRoute(
    "admin",
    userData?.page_access,
    "/dashboard-admin",
  );

  const guard = (slug, redirectTo, element) => {
    const access = userData?.page_access?.[slug];
    const canEdit =
      access === undefined || access === null || access === "view_edit";
    return canEdit ? element : <Navigate to={redirectTo} replace />;
  };

  return (
    <Routes>
      {/* Dashboard Routes */}
      <Route path="/dashboard-admin" element={<Dashboard />} />
      {/* Fleet Management Routes */}
      <Route path="/fleet-management" element={<FleetManegement />} />
      <Route
        path="/fleet-management-detail"
        element={<FleetManagementDetail setUser={setUser} />}
      />
      <Route
        path="/edit-company-onboarding"
        element={guard("fleet-management", "/fleet-management", <EditCompanyOnboarding />)}
      />

      <Route
        path="/subscription-payments-admin"
        element={<SubscriptionPayments />}
      />

      {/* Fuel Vendor Routes */}
      <Route path="/fuel-vendors-admin" element={<FuelVendors />} />
      <Route path="/vendor-detail" element={<FuelVendorDetails />} />
      <Route
        path="/edit-vendor-detail"
        element={guard("fuel-vendors", "/fuel-vendors-admin", <EditVendorDetails />)}
      />

      {/* System Configuration Routes */}
      <Route path="/system-configuration" element={<SystemConfiguration />} />
      <Route
        path="/edit-module-price"
        element={guard("system-configuration", "/system-configuration", <EditModulePrice />)}
      />
      <Route path="/fuel-brand-details" element={<FuelBrandDetails />} />
      <Route
        path="/add-fuel-brand"
        element={guard("system-configuration", "/system-configuration", <AddFuelBrand />)}
      />
      <Route
        path="/edit-fuel-brand"
        element={guard("system-configuration", "/system-configuration", <EditFuelBrand />)}
      />
      <Route
        path="/add-fuel-type"
        element={guard("system-configuration", "/system-configuration", <AddFuelType />)}
      />
      <Route
        path="/edit-fuel-type"
        element={guard("system-configuration", "/system-configuration", <EditFuelType />)}
      />
      <Route
        path="/edit-fleet-manager-document"
        element={guard("system-configuration", "/system-configuration", <EditFleetManagerDocument />)}
      />
      <Route
        path="/edit-fuel-vendor-document"
        element={guard("system-configuration", "/system-configuration", <EditFuelVendorDocument />)}
      />
      <Route
        path="/add-fleet-manager-document"
        element={guard("system-configuration", "/system-configuration", <AddFleetManagerDocument />)}
      />
      <Route
        path="/add-vehicle-document"
        element={guard("system-configuration", "/system-configuration", <AddVehicleDocument />)}
      />
      <Route
        path="/edit-vehicle-document"
        element={guard("system-configuration", "/system-configuration", <EditVehicleDocument />)}
      />
      <Route
        path="/add-driver-document"
        element={guard("system-configuration", "/system-configuration", <AddDriverDocument />)}
      />
      <Route
        path="/edit-driver-document"
        element={guard("system-configuration", "/system-configuration", <EditDriverDocument />)}
      />
      <Route
        path="/add-fuel-vendor-document"
        element={guard("system-configuration", "/system-configuration", <AddFuelVendorDocument />)}
      />

      {/* Transaction Routes */}
      <Route path="/transactions-admin" element={<Transactions />} />
      <Route path="/transaction-detail" element={<TransactionDetails />} />
      {/* Credit And Billings Routes */}
      <Route path="/credits-billings-admin" element={<CreditsBillings />} />
      <Route path="/fleet-credit-details" element={<FleetCreditDetails />} />
      <Route path="/credit-adjustments" element={<CreditAdjustments />} />
      {/* Reports & Analytics Routes */}
      <Route path="/reports-analytics" element={<ReportsAnalytics />} />
      {/* Approvals And  Request Routes */}
      <Route path="/approvals-requests" element={<ApprovalsRequests />} />
      <Route path="/vendor-onboarding" element={<VendorOnboarding />} />
      <Route path="/company-onboarding" element={<CompanyOnboarding />} />
      <Route path="/credit-topup-request" element={<SubscriptionPaymentRequest />} />
      <Route
        path="/subscription-payment-request"
        element={<SubscriptionPaymentRequest />}
      />
      {/* User Management Routes */}
      <Route path="/user-management-admin" element={<UserManagement />} />
      <Route path="/user-details" element={<UserDetails />} />
      {/* Setting & Permissions Routes */}
      <Route
        path="/settings-permissions-admin"
        element={<SettingsPermissions />}
      />
      <Route path="/settings-permissions" element={<SettingsPermissions />} />
      {/* Audit Trail Routes */}
      <Route path="/audit-trail" element={<AuditTrail />} />
      {/* QR Management Routes */}
      <Route path="/qr-management" element={<QRManagement />} />
      <Route path="/qr-active-detail" element={<QRActiveDetail />} />
      <Route path="/fuel-cards" element={<FuelCards />} />
      {/* Profile Routes */}
      <Route
        path="/profile-admin"
        element={<MyProfilePage setUser={setUser} />}
      />
      <Route path="/selection" element={<Select setUser={setUser} />} />
      <Route path="*" element={<Navigate to={fallbackRoute} />} />
    </Routes>
  );
};

export default FleeiqAdminRoutes;
